// extracted by mini-css-extract-plugin
export default {"button":"CatFactWidget_button__CYa2k","factWrapper":"CatFactWidget_factWrapper__9Q900","title":"CatFactWidget_title__aBZvr"};